import { parseJSON } from 'date-fns';
import { Stack, Typography } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';

import { Order } from '@barboxx/models';

import { BaseTextInput } from './BaseTextInput';

export function FaceVerificationOverrideSection({
    override,
}: {
    override: NonNullable<
        Order.DetailsResponse['pickupFaceVerificationOverride']
    >;
}) {
    return (
        <Stack gap={2}>
            <Typography variant="subtitle2">Override</Typography>
            <Stack direction="row" gap={2} flexWrap="wrap">
                <BaseTextInput
                    label="Override Reason"
                    value={override.reason}
                    sx={{ flex: 1, minWidth: 200 }}
                />
                <DateTimePicker
                    label="Override At"
                    value={parseJSON(override.at)}
                    format="MM/dd/yyyy hh:mm:ss aa"
                    readOnly
                    sx={{ minWidth: 240 }}
                />
                <BaseTextInput
                    label="Override By (User Id)"
                    value={override.userId}
                    sx={{ minWidth: 160 }}
                />
            </Stack>
        </Stack>
    );
}
